export default __webpack_public_path__ + "static/media/Sanya-2.726ca03f.mp4";